const OFFICE_APP_ENV = process.env.REACT_APP_OFFICE_APP_ENV;

let API_URL: string;
let CLIENT_ID: string;

if (OFFICE_APP_ENV === "production") {
  API_URL = process.env.REACT_APP_API_PROD_URL;
  CLIENT_ID = process.env.REACT_APP_CLIENT_ID_PROD;
} else {
  API_URL = process.env.REACT_APP_API_DEV_URL;
  CLIENT_ID = process.env.REACT_APP_CLIENT_ID_DEV;
}

export { API_URL, CLIENT_ID };
